import HeaderVariantA from './header_variant_a';

export default HeaderVariantA;
